/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_Proxy_RtInputs */



/**
* | output |
* | --- |
* | "Proxy RT" |
*
* @param {Media_Import_Source_Proxy_RtInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_proxy_rt = /** @type {((inputs?: Media_Import_Source_Proxy_RtInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_Proxy_RtInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Proxy RT")
	if (locale === "de") return /** @type {LocalizedString} */ ("Proxy RT")
	if (locale === "it") return /** @type {LocalizedString} */ ("Proxy RT")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прокси RT")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proxy RT")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("代理RT")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロキシRT")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रॉक्सी आरटी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("RT por procuração")
	return /** @type {LocalizedString} */ ("Proxy RT")
});